import { RULE_ACTIVITY_MANAGEMENT_INSTRUCTION } from '@/consts.js';
import Ad from '@/entities/Ad';
import BaseEntity from '@/entities/BaseEntity';
import Post from '@/entities/Post';
import Rule from '@/entities/Rule';
import User from '@/entities/User';

export default class RuleActivityManagementQueueItem extends BaseEntity {
  id = null;
  is_current = null;
  post = null;
  ad = null;
  rule = null;
  handled_by = null;
  handled_at = null;
  auto_handling_at = null;
  instruction = null;
  affected_ad_count = null;
  created_at = new Date();

  _entityFields = {
    post: Post,
    ad: Ad,
    handled_by: User,
    rule: Rule,
  };

  constructor(rawData) {
    super();
    this.updateWith(rawData);

    if (this.handled_at) {
      this.handled_at = new Date(this.handled_at);
    }
    if (this.auto_handling_at) {
      this.auto_handling_at = new Date(this.auto_handling_at);
    }
  }

  get isHandled() {
    return this.handled_at !== null;
  }

  get isAccepted() {
    return this.instruction === RULE_ACTIVITY_MANAGEMENT_INSTRUCTION.ACCEPT;
  }

  get isRejected() {
    return this.instruction === RULE_ACTIVITY_MANAGEMENT_INSTRUCTION.REJECT;
  }

  get canBeAcceptedAfterRejection() {
    return this.isHandled && this.isRejected && this.is_current;
  }
}
